import * as bootstrap from 'bootstrap'

// Vite scopes modules, so attach shared globals for legacy scripts.
  ;(globalThis as any).bootstrap = bootstrap
